import { IPm } from 'APIPackage/KnmModule/interfaces/IPm';
import { convertKnmDocumentAttachmentsFormValuesToKnmData } from 'KnmPackage/MainModule/common/convertKnmDocumentAttachmentsFormValuesToKnmData';

import { IKnmPmForm } from '../interfaces/IKnmPmForm';

export const convertContentWarningFormValuesToKnmData = (
  formAttachments: IKnmPmForm['contentWarningAttachments'],
  contentWarningData: IPm['contentWarning'] | undefined,
): IPm['contentWarning'] => {
  if (!formAttachments) {
    return null;
  }

  return {
    active: contentWarningData?.active || null,
    attachments: convertKnmDocumentAttachmentsFormValuesToKnmData(formAttachments),
    correlationToken: contentWarningData?.correlationToken || null,
    description: contentWarningData?.description || null,
    guid: contentWarningData?.guid || null,
    type: contentWarningData?.type || null,
  };
};
